/* eslint-disable @typescript-eslint/no-explicit-any */
import { DropdownOption } from 'app/pages/RoomReportViewPhotoPage/hook';
import heic2any from 'heic2any';

export const fetchAndConvertHeicToPng = async (url: string): Promise<string> => {
  const response = await fetch(url);
  const blob = await response.blob();
  const pngBlob = (await heic2any({
    blob,
    toType: 'image/png',
    quality: 0.9
  })) as Blob;
  return URL.createObjectURL(pngBlob);
};

export const formatName = (input: string): string => {
  const match = input.match(/^([a-zA-Z]+)(\d+)$/);
  if (!match) return input;

  const [, wordPart, numberPart] = match;
  const capitalizedWord = wordPart.charAt(0).toUpperCase() + wordPart.slice(1).toLowerCase();
  return `${capitalizedWord} ${numberPart}`;
};
export type TStorage = {
  fileName: string;
  fileType: string;
  id: number;
  key: string;
  type: string;
  updatedAt: string;
  url: string;
};
export const convertFileToStorage = (type: string, storage: TStorage) => {
  return storage.url
    ? storage.url
    : process.env.REACT_APP_API_URL + `/storages/${type}/` + storage.id;
};

/**
 *
 * @param item
 * @returns string
 */
export const getNameOption = (item: DropdownOption) => {
  return item.name || item.dropdownValues[0]?.name;
};

/**
 *
 * @param obj
 * @returns payload
 */
export const appendDynamicOptionForPayload = (obj: Record<string, any>) => {
  const payload: Record<string, string>[] = [];
  for (const key in obj) {
    if (!key.startsWith('option') || typeof obj[key] === 'object') continue;

    let optionName = ' ';
    if (key.startsWith('option') && !key.endsWith('_name') && obj[key] !== 'OTHER' && obj[key]) {
      optionName = key.slice(7);
      payload.push({ [optionName]: obj[key] });
    }
    if (key.endsWith('_name') && obj[key.slice(0, -5)] === 'OTHER' && obj[key]) {
      optionName = key.slice(7);
      optionName = optionName.slice(0, -5);
      payload.push({ [optionName]: obj[key] });
    }
  }
  return payload;
};
/**
 * single_
 * @param obj
 * @returns payload
 */
export const appendDynamicSingleForPayload = (obj: Record<string, any>) => {
  const payload: Record<string, string>[] = [];
  for (const key in obj) {
    if (!key.startsWith('single') || typeof obj[key] === 'object') continue;

    let optionName = ' ';
    if (key.startsWith('single') && !key.endsWith('_name') && obj[key] !== 'OTHER' && obj[key]) {
      optionName = key.slice(7);
      payload.push({ [optionName]: obj[key] });
    }
    if (key.endsWith('_name') && obj[key.slice(0, -5)] === 'OTHER' && obj[key]) {
      optionName = key.slice(7);
      optionName = optionName.slice(0, -5);
      payload.push({ [optionName]: obj[key] });
    }
  }

  return payload;
};

export const capitalizeFirstLetter = (text: string) => {
  if (!text) return '';

  const cleaned = text.replace(/_/g, ' ');

  return cleaned
    .split(' ')
    .map((word) => (word ? word.charAt(0).toUpperCase() + word.slice(1).toLowerCase() : ''))
    .join(' ');
};

/**
 * Body for PUT /inspections/locations/:submitId must use real integers: JSON.stringify turns NaN into null,
 * which fails validation (clientId: null).
 */
export function resolveInspectionLocationPatchIds(row: {
  room?: { id?: number; clientId?: number; client?: { id?: number } } | null;
  submitted?: { roomId?: number };
}): { clientId: number; roomId: number; ok: boolean } {
  const clientId = Number(row.room?.clientId ?? row.room?.client?.id);
  const roomId = Number(row.room?.id ?? row.submitted?.roomId);
  const ok = Number.isFinite(clientId) && clientId > 0 && Number.isFinite(roomId) && roomId > 0;
  return { clientId, roomId, ok };
}
